// extracted by mini-css-extract-plugin
export var promocode = "promocode-module--promocode--1ROi-";